( function () {
   
    'use strict';

    ( function ( $ ) {
     
      $('.hospitality-video-content').magnificPopup({
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $("body").addClass("overflow");
         },
          close: function() {
            $("body").removeClass("overflow");
          }
        }
    });
    $('.buytickets-video-content').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      callbacks: {
        open: function() {
          $("body").addClass("overflow");
       },
        close: function() {
          $("body").removeClass("overflow");
        }
      }
  });
     

        $('.accordion-title-main').click(function(j) {
    
            var dropDown = $(this).closest('.accordion-item').find('.accordion-content');
            $(this).closest('.accordion').find('.accordion-content').not(dropDown).slideUp();
            
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
            } else {
              $(this).closest('.accordion').find('.accordion-title-main.active').removeClass('active');
              $(this).addClass('active');
            }
            
            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
        });

        $(' .accordion-btn a.acc-more').click(function () {
          $(this).find('.accordion').toggleClass('slidedown');
          $(this).parent().parent().toggleClass('active');
          $(this).toggleClass('add');
            if($(this).hasClass('add')){
              $(this).html('Read Less');
            }
            else{
              $(this).html('Read More');
            }
            return false;
        });
    
        
    } )( jQuery );
} )();
